import { createFileRoute } from '@tanstack/react-router';
import { UserFrame } from '@/app/shell/me-layout';
import { MinutesPage } from '@/features/minutes/pages/minutes-page';

/**
 * A PV (meeting minutes): no organisation in the address, so the link of a notice works for a
 * partner of a shared space too. Authorization is the API's (the PV is read, and written, only for
 * a person allowed to).
 */
export const Route = createFileRoute('/_auth/minutes/$spaceId/$minutesId')({
  component: MinutesRoute,
});

function MinutesRoute() {
  const { spaceId, minutesId } = Route.useParams();
  return (
    <UserFrame>
      <MinutesPage spaceId={spaceId} minutesId={minutesId} />
    </UserFrame>
  );
}
